import { Component, OnInit } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { EMailService } from '../../../services/email.service';
import { EDeliveryService } from '../../../services/edelivery.service';
import { Observable, Subscription } from 'rxjs';
import { Email } from '../../../models/e-mail.model';
import { Emailresponse } from '../../../models/emailresponse.model';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EdeliveryLabels } from '../../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'addEmail',
    templateUrl: './addEmail.component.html',
    styleUrls: ['./addEmail.component.css']
})
export class AddEmailComponent implements OnInit {
    emailAddress: string = '';
    confirmEmail: string = '';
    errorMessage: string = '';
    emailresponse: Observable<Emailresponse>;
    addEmailSubscription: Subscription;
    routeSubscription: Subscription;

    currentEmails: Email[];

    // Labels
    addEmailTitle = EdeliveryLabels.ADD_EMAIL_ADDRESS;
    emailLabel = EdeliveryLabels.EMAIL_LABEL;
    confirmEmailLabel = EdeliveryLabels.CONFIRM_EMAIL_LABEL;
    invalidEmailAddress = EdeliveryLabels.INVALID_EMAIL;
    invalidEmailAddressMaxLength = EdeliveryLabels.INVALID_EMAIL_MAXLENGTH;
    saveLabel = EdeliveryLabels.SAVE;
    cancelLabel = EdeliveryLabels.CANCEL;

    emailForm = new FormGroup({
        'email': new FormControl('', [
            Validators.required,
            Validators.email,
            Validators.maxLength(64),
            Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
        ]),
        'confirmEmail': new FormControl('', [
            Validators.required,
            Validators.email,
            Validators.maxLength(64),
            Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
        ])
    });

    constructor(private emailService: EMailService, private eDeliveryService: EDeliveryService, private log: LogService, private dialogRef: MatDialogRef<AddEmailComponent>,
                private router: Router, private route: ActivatedRoute, private translate: PershingTranslationService) {
                    if (this.translate) {
                        this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
                    }
                 }

    ngOnInit() {
        this.log.info('Add email is called');
        this.currentEmails = this.emailService.getUserEmails();
        console.log('current emails: ', this.currentEmails);
    }

    ngOnDestroy() {
        if (this.addEmailSubscription) {
            this.addEmailSubscription.unsubscribe();
        }
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    // Gets called when Add button is clicked on.
    addEmail(): void {
        this.emailAddress = this.emailForm.value.email.toUpperCase();
        this.confirmEmail = this.emailForm.value.confirmEmail.toUpperCase();
        if (this.emailAddress !== this.confirmEmail) {
            this.log.info('Email and confirm e-mail do not match');
            this.errorMessage = 'Email and confirm e-mail do not match';
            if (this.translate.translate.store.currentLang === 'es') {
                this.errorMessage = 'La dirección de correo electrónico ingresada en los dos campos no coincide. Corríjalos.';
            }
            return;
        }
        if (this.currentEmails) {
            for (let i = 0; i < this.currentEmails.length; i++) {
                if (this.currentEmails[i].emailAddress === this.emailAddress) {
                    this.errorMessage = 'Only one valid e-mail address is required. If you choose to provide more than' +
                                       ' the one required address, each e-mail you enter must be distinct from the previous entry.';
                    if (this.translate.translate.store.currentLang === 'es') {
                        this.errorMessage = 'Solo se requiere una dirección de correo electrónico válida.' +
                        ' Si elige proporcionar más que la dirección requerida,' +
                        ' cada correo electrónico que ingrese debe ser diferente de la entrada anterior.';
                    }
                    return;
                }
            }
        }
        let email: Email = new Email(this.emailAddress);
        this.emailService.addEmails(email);
        this.emailService.showEmailPopup = false;
        this.eDeliveryService.triggerLoadingIcon(true);
        this.emailService.updateEmailTriggered = true;
        this.close();
    }
    close(interuptPromoPopup?) {
        if (interuptPromoPopup) {
            this.routeSubscription = this.route.queryParamMap.subscribe(routeResponse => {
                if (routeResponse) {
                    let myParamKeys = routeResponse.keys;
                    let myQueryParams = {};
                    myParamKeys.forEach(element => {
                        if (element === 'showPopup') {
                            myQueryParams[element] = false;
                        } else {
                            myQueryParams[element] = routeResponse.get(element);
                        }
                    });
                    this.router.navigate(
                        [],
                        {
                            relativeTo: this.route,
                            queryParams: myQueryParams
                        });
                }
            });
        }
        this.dialogRef.close();
    }

}
